import request from '@/utils/request'

export function getErpPushStatus() {
  return request({
    url: "/offlineApi/optList/pushTarget",
    method: "get"
  })
}

export function getUserPurchaseBrands() {
  return request({
    url: "/offlineApi/optList/purchase-brands",
    method: "get"
  })
}

export function getStoreCodeList() {
  return request({
    url: "/offlineApi/optList/stores",
    method: "get"
  })
}

export function getWarehouseList() {
  return request({
    url: "/offlineApi/optList/warehouses",
    method: "get"
  })
}

export function exportProductModel() {
  return request({
    url: "/offlineApi/agentDeliveries/export",
    method: "post",
    responseType: 'blob'
  })
}

export function auditOperator() {
  return request({
    url: "/offlineApi/pay/options/auditOperator",
    method: "get"
  })
}

export function auditState() {
  return request({
    url: "/offlineApi/pay/options/auditState",
    method: "get"
  })
}

export function fundState() {
  return request({
    url: "/offlineApi/pay/options/fundState",
    method: "get"
  })
}

export function fundType() {
  return request({
    url: "/offlineApi/pay/options/fundType",
    method: "get"
  })
}

export function tradeChannel() {
  return request({
    url: "/offlineApi/pay/options/tradeChannel",
    method: "get"
  })
}

export function tradeType() {
  return request({
    url: "/offlineApi/pay/options/tradeType",
    method: "get"
  })
}

export function seriesList(brandId) {
  return request({
    url: `/offlineApi/optList/series/${brandId}`,
    method: "get"
  })
}

export function brandsList() {
  return request({
    url: "/offlineApi/optList/brands",
    method: "get"
  })
}

// 根据品牌id获取商品编码
export function getBarcodeByBrandId(brandId) {
  return request({
    url: `/offlineApi/optList/commodityCodes/${brandId}`,
    method: "get"
  })
}